<template>
  <div>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader class="p-1">
            <CRow>
              <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">
                <strong>{{$t('sidebars.payroll')}}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton
                        v-if="factor.recStatus==0"
                        class="mr-1 ml-1"
                        size="sm"
                    color="secondary"
                    @click="open_date_dialog=true"
                >{{ $t("buttons.save") }}
                </CButton>
                <CButton
                        v-if="factor.recStatus==0"
                        class="mr-1 ml-1"
                        size="sm"
                    color="secondary"
                    @click="$router.push({path:'/dashboard/users/edit-payroll/'+$route.params.id})"
                >{{ $t("buttons.edit") }}
                </CButton>
                <CButton
                    class="mr-1"
                    size="sm"
                    color="secondary"
                >{{ $t("buttons.print") }}
                </CButton>

              </CCol>
            </CRow>
            <!--        </div>-->

            <!-- Right aligned nav items -->
            <!--      </CCollapse>-->
          </CCardHeader>

          <CCardBody>
            <CRow>
                  <CCol col="3">
                    <p>{{$t('components.startDate')}}: {{get_date(factor.fromDate)}}</p>
                  </CCol>
                  <CCol col="3">
                    <p>{{$t('components.endDate')}}: {{get_date(factor.toDate)}}</p>
                  </CCol>

            </CRow>
            <CDataTable
                :items="filtered_items_customer"
                :fields="fields"
                :items-per-page="8"
                hover

                :responsive="false"
                add-table-classes="width-2000 overfly-x-auto"
                style="overflow-x: scroll"
                sorter
                pagination
            >
              <template #row_id="{item}">

                <td style="text-align: center">

                <p >{{ item.row_id + 1 }}</p>

                </td>

              </template>
              <template #personName="{item}">

                <td>
                  <p >{{ item.personName }}</p>

                </td>

              </template>
              <template #surName="{item}">
                <td>
                  <p >{{ item.surName }}</p>
                </td>
              </template>
              <template #personCode="{item}">
                <td>
                  <p v-if="item.personCode!=null" >{{ item.personCode }}</p>
                </td>
              </template>
              <template #phone="{item}">
                <td>
                  <p >{{ item.mobileNo }}</p>

                </td>

              </template>

              <template #costCenter="{item}">
                <td>
                  {{item.costCenter}}
<!--                  <CSelect class="p-0 m-0" :options="get_cost_centes(item)"-->
<!--                           :value.sync="item.costCenter"-->
<!--                  />-->
                </td>

              </template>


              <template #extraHours="{item}">
                <td>
                  <p  >{{ (item.extraHours) }}</p>

                </td>
              </template>
              <template #holidayHours="{item}">
                <td>
                  <p  >{{ (item.holidayHours) }}</p>

                </td>
              </template>
              <template #nightHours="{item}">
                <td>
                  <p  >{{ (item.nightHours) }}</p>

                </td>
              </template>

              <template #wage="{item}">
                <td>
                  <label class="p-0 mr-2 ml-2" >{{item.wage}}</label>

                </td>
              </template>

              <template #note="{item}">
                <td>
                  <p  >{{ (item.note) }}</p>

                </td>
              </template>
              <template #hours="{item}">
                <td>
                  <p  >{{ (item.hours) }}</p>

                </td>
              </template>
              <template #penaltyHours="{item}">
                <td>
                  <p  >{{ (item.penaltyHours) }}</p>

                </td>
              </template>
              <template #SumHours="{item}">
                <td>
                  <p  >{{ (item.sumWork) }}</p>

                </td>
              </template>

              <template #reward="{item}">
                <td>
                  <p  >{{ (item.reward) }}</p>

                </td>
              </template>
              <template #amount="{item}">
                <td>
                  <p  >{{ get_currency(item.amount) }}</p>
                </td>
              </template>
              <template #received="{item}">
                <td>
                  <p  >{{ get_currency(item.received) }}</p>

                </td>
              </template>
              <template #totalPrice="{item}">
                <td>

                  <p  >{{ get_currency(item.payableAmount) }}</p>
                </td>
              </template>



              <template #under-table>
                <CRow class="width-2000">

                  <CCol></CCol>
                  <CCol></CCol>
                  <CCol></CCol>
                  <CCol></CCol>
                  <CCol></CCol>
                  <CCol></CCol>


                  <CCol>{{ $t('totalCirculation') }}</CCol>
                  <CCol>{{ get_currency(calculate_items(filtered_items_customer,'amount')) }}</CCol>
                  <CCol>{{ get_currency(calculate_items(filtered_items_customer,'received')) }}</CCol>
                  <CCol>{{ get_currency(calculate_items(filtered_items_customer,'payableAmount')) }}</CCol>
                  <CCol></CCol>
                  <CCol></CCol>

                </CRow>


              </template>
            </CDataTable>


          </CCardBody>

        </CCard>
      </CCol>
    </CRow>
    <CModal
        :show.sync="open_date_dialog"
        :no-close-on-backdrop="true"
        color="transparent"
        border-color="primary"

        :title="$t('components.changeStatus')"
    >

      <CRow>
        <CCol col="12">

          <CRow form class="form-group">
            <label tag="label" sm="12" class="col-form-label">
              {{$t('docDate')}}
            </label>
            <CCol sm="12">
              <date-picker
                  v-model="doc_date"
                  :min="get_min_doc_date()"
                  :max="get_max_doc_date()"
              ></date-picker>
            </CCol>
          </CRow>



        </CCol>
      </CRow>
      <template #footer>
        <CButton @click="add_salary()"
                 color="success"
        >{{ $t("buttons.ok") }}
        </CButton>
        <CButton
            @click="open_date_dialog = false"
            color="danger"
        >{{ $t("buttons.cancel") }}
        </CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items_data = [];
import CInputNumber from "../includes/CInputNumber";
import moment from 'moment-jalaali'
import Treeselect from "@riophae/vue-treeselect";

export default {
  name: 'Login',
  components:{
    Treeselect,
    CInputNumber
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      name: '',
      open_date_dialog:false,
      file: '',
      doc_date: '',
      factor: {},
      color: '#ffffff',
      night_ration: 2,
      extra_ration: 2,
      holiday_ration: 2,
      search_data: '',
      previewImage: '',
      selected_template: 0,
      description: '',
      saleMethodModal: false,
      method_list: [],
      selected_method: '',
      selected_person: 0,
      start_date_week: '',
      start_date_month: '',
      start_date: '',
      end_date: '',
      items_customer: [],
      filtered_items_customer: [],
      fields: [
        {key: 'row_id', label: this.$t('tables.row'),sorter:false, _style: 'width:30px'},
        {key: 'personCode', label: this.$t('personalNo'), _style: 'width:50px'},
        {key: 'personName', label: this.$t('name'), _style: 'width:50px'},
        {key: 'surName', label: this.$t('lastName'), _style: 'width:70px'},
        {key: 'hours', label: this.$t('totalWork'), _style: 'width:50px'},
        {key: 'extraHours', label: this.$t('extraJob'), _style: 'width:50px'},
        {key: 'holidayHours', label: this.$t('holidayJob'), _style: 'width:50px'},
        {key: 'nightHours', label: this.$t('nightJob'), _style: 'width:50px'},

        {key: 'penaltyHours', label: this.$t('minusWork'), _style: 'width:50px'},
        {key: 'SumHours', label: this.$t('sumWork'), _style: 'width:50px'},

        {key: 'reward', label: this.$t('Reward')+" "+this.currency_symbol() , _style: 'width:50px'},
        {key: 'amount', label: this.$t('tables.amount') , _style: 'width:50px'},
        {key: 'received', label: this.$t('receivedPrice'), _style: 'width:50px'},
        {key: 'totalPrice', label: this.$t('payablePrice'), _style: 'width:50px'},
        {key: 'costCenterTitle', label: this.$t('costCenter'), _style: 'width:50px'},
        {key: 'wage', label: this.$t('wage'), _style: 'width:50px'},
        {key: 'note', label: this.$t('components.documentSummary'), _style: 'width:150px'},

        // {key: 'isCustomer', label: this.$t('tables.isCustomer'), _style: 'width:10%'},
        // {key: 'isVendor', label: this.$t('tables.isVendor'), _style: 'width:10%'},
        // {key: 'isWorker', label: this.$t('tables.isWorker'), _style: 'width:10%'},
        // {key: 'permission', label: this.$t('tables.role'), _style: 'width:5%'},
        // {key: 'saleMethodName', label: this.$t('tables.saleMethod'), _style: 'width:10%'},

        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},

      ],
      items_worker: [],
      // fields,

      items_vendor: [],
      // fields,

      details: [],
      templates_items: [
        {template_id: 'One', name: 'A'},
        {template_id: 'Two', name: 'B'},
        {template_id: 'Three', name: 'C'}
      ],
      collapseDuration: 0,
      status_form: 0
    }
  },
  computed1: {},
  mounted() {
    this.get_lists();
    this.$root.root_validate_errors = [];
    this.get_method_lists();
this.doc_date = this.get_today()
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'start_date': function () {
      var start = moment(this.start_date, 'YYYY-MM-DD');
      this.end_date = start.add(6, 'day').format('YYYY-MM-DD');

      this.start_date_week = moment(this.start_date, 'YYYY-MM-DD').week();
      this.start_date_month = start.format('MMMM');
      if (this.$i18n.locale == "fa") {
        start = start.locale('fa');
        this.start_date_month = start.locale('fa').format('jMMMM');

        this.start_date_week = start.locale('fa').format('jw');
      }else{
        start = start.locale(this.$i18n.locale);
        this.start_date_month = start.locale(this.$i18n.locale).format('MMMM');

        this.start_date_week = start.locale(this.$i18n.locale).format('w');
      }
    },
    'search_data': function () {
      this.filtered_items_customer = this.items_customer.filter(x =>
          x.personCode.includes(this.search_data) || x.userName.includes(this.search_data) || x.surName.includes(this.search_data))
    }
  },
  methods: {
    get_all_total_price(){
      var total_price = 0;
      for (var i = 0; i < this.items_customer.length; i++) {
      total_price = total_price+ this.get_total_wage(this.items_customer[i])
      }
      return total_price
    },
    get_sum_hours(item) {
      var hours = 0;

      if (item.hours != null && item.hours != '') {
        hours = hours + parseInt(item.hours);
      }
      if (item.extraHours != null && item.extraHours != '') {
        hours = hours + parseInt(item.extraHours)+ ((parseInt(item.extraHours) * this.extra_ration)/100);
      }
      if (item.holidayHours != null && item.holidayHours != '') {
        hours = hours + parseInt(item.holidayHours) +((parseInt(item.holidayHours) * this.holiday_ration)/100);
      }
      if (item.nightHours != null && item.nightHours != '') {
        hours = hours + parseInt(item.nightHours)+ ((parseInt(item.nightHours) * this.night_ration)/100);
      }
      if (item.penaltyHours != null && item.penaltyHours != '') {
        hours = hours - parseInt(item.penaltyHours);
      }

      return parseFloat(hours).toFixed(2);
    },
    get_sum_wage(item) {
      var wage = 0;
      var hours = this.get_sum_hours(item);
      if (item.wage != null && item.wage != '') {
        wage = hours * (item.wage).toString().replace(/,/g, '');
      }
      if (item.reward != null && item.reward != '') {
        wage = wage + parseFloat((item.reward).toString().replace(/,/g, ''));
      }
      item.price=wage;
      return wage;
    },
    get_total_wage(item) {
      var total_wage = 0
      if (item.received == null || item.received == '') {
        total_wage = this.get_sum_wage(item);
      }else{
         total_wage = this.get_sum_wage(item) - parseFloat((item.received).toString().replace(/,/g, ''));
      }
      item.totalPrice = total_wage
      return total_wage ;
    },
    get_cost_centes(item) {
      var centes = []
      for (var i = 0; i < item.costCenters.length; i++) {
        centes.push({label: item.costCenters[i].title, value: item.costCenters[i].id})
      }
      return centes
    },

    get_method_lists() {
      var self = this;

      const formData = new FormData();


      axios.post('GetBusinessPublic', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.night_ration = content_data.data.nightJob
          self.extra_ration = content_data.data.upperJob
          self.holiday_ration = content_data.data.hollidayJob

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_lists() {
      var self = this;


      const formData = new FormData();

      var url = "GetPayrollDocById";

      formData.append('FactorId', self.$route.params.id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items_customer = content_data.data.details.map((item, row_id) => {
            return {...item, row_id}
          });
self.factor = content_data.data
          for (var i = 0; i < self.items_customer.length; i++) {
            // self.items_customer[i].penaltyHours = '0';
            self.items_customer[i].extraHours = self.items_customer[i].overtime
            self.items_customer[i].holidayHours = self.items_customer[i].holiday
            self.items_customer[i].nightHours = self.items_customer[i].nightShift
            self.items_customer[i].hours = self.items_customer[i].totalWork
            self.items_customer[i].penaltyHours = self.items_customer[i].minusWork
            self.items_customer[i].received = self.items_customer[i].receivedAmount

            if (self.items_customer[i].personCode == null) {
              self.items_customer[i].personCode = ''
            }
            if (self.items_customer[i].personName == null) {
              self.items_customer[i].personName = ''
            }
            if (self.items_customer[i].surName == null) {
              self.items_customer[i].surName = ''
            }
          }
          self.filtered_items_customer = self.items_customer;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    prepare_salary() {

    },
    add_salary() {
      var self = this;
      const formData = new FormData();

      var url = "AddPayrollDocToFinal";


      formData.append('Id', self.$route.params.id );
      formData.append('docDate', self.doc_date );

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;
        self.$root.modal_component.show_api_response_modals(response);
        self.open_date_dialog = false
        self.get_lists();

      })
          .catch(function (error) {

            console.log(error);
          });

    },


  }
}

</script>
<style>
.width-2000 {
  width: 1500px !important;
}
</style>
